import { Card, Divider, Flex, Form, Upload } from 'antd'
import { useTheme } from 'antd-style'

import {
  InquiryDocumentResponse,
  InventoryDocumentState,
  IssuanceDocumentResponse
} from 'src/api/requests'
import { CustomItemRender, Text } from 'src/components'
import { CommentSectionAdmin } from 'src/features/stock-administration'
import { FileDocument, onDownloadFile } from 'src/hooks'
import { useLocales } from 'src/locales'

import { useStyles } from '../styles'

type Props = {
  data?: InquiryDocumentResponse
  issuanceData?: IssuanceDocumentResponse
}

export const IssuanceBody = ({ data, issuanceData }: Props) => {
  const { t } = useLocales()
  const { styles } = useStyles()
  const palette = useTheme()

  const mediaFiles = data?.mediaFiles?.length
    ? data.mediaFiles
    : issuanceData?.mediaFiles || []

  const isRejected = data?.state === InventoryDocumentState.REJECTED

  return (
    <>
      {data?.beneficiaryComment && isRejected && (
        <Card
          title={t('epidemiology.refuse_reason')}
          className={styles.commentCardWrapper}
        >
          <Divider className={styles.commentDivider} />
          <Flex vertical gap={8} className={styles.commentCard}>
            <div className={styles.commentBeneficiary}>
              {data?.beneficiaryComment}
            </div>
            <Text size="lg" color={palette.colorTextTertiary}>
              {data?.beneficiaryCommentBy?.firstName}{' '}
              {data?.beneficiaryCommentBy?.lastName} - {data?.supplier?.name}
            </Text>
          </Flex>
        </Card>
      )}

      {mediaFiles?.length > 0 && (
        <Card title={t('stock_applications.uploaded_documents')}>
          <Form.Item name="docs" className="full-width">
            <Upload
              itemRender={(_, file: FileDocument) => (
                <CustomItemRender
                  file={file}
                  onDownload={() => onDownloadFile(t, file?.id, file?.name)}
                />
              )}
              fileList={mediaFiles?.map((file, index) => ({
                ...file,
                uid: String(index),
                name: file?.name || `file-${index}`
              }))}
              disabled
            />
          </Form.Item>
        </Card>
      )}

      {data && <CommentSectionAdmin data={data} issuanceData={issuanceData} />}
    </>
  )
}
